/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { NbSharedModule } from '../shared/shared.module';

import { NbRouteTabsetComponent } from './route-tabset.component';

@NgModule({
  imports: [
    NbSharedModule,
  ],
  declarations: [
    NbRouteTabsetComponent,
  ],
  exports: [
    NbRouteTabsetComponent,
  ],
})
export class NbRouteTabsetModule { }



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@nebular/theme/components/route-tabset/route-tabset.module.ts